<template>
    <Html
        :dir="head.htmlAttrs.dir"
        :lang="head.htmlAttrs.lang"
    >
        <Head>
            <Title>{{ title }}</Title>
            <template
                v-for="link in head.link"
                :key="link.id"
            >
                <Link
                    :id="link.id"
                    :href="link.href"
                    :hreflang="link.hreflang"
                    :rel="link.rel"
                />
            </template>
            <template
                v-for="meta in head.meta"
                :key="meta.id"
            >
                <Meta
                    :id="meta.id"
                    :content="meta.content"
                    :property="meta.property"
                />
            </template>
        </Head>
        <Body
            :class="{
                'is-staging': isStaging,
                'is-front-page': isFrontPage,
                'has-welcome-bonus-header': showWelcomeBonusHeader,
            }"
            class="antialiased"
        >
            <div class="flex flex-col min-h-screen relative">
                <div class="z-1 flex flex-col min-h-screen">
                    <layout-staging v-if="isStaging" />
                    <layout-impersonating v-if="user?.is_impersonating" />

                    <promotion-top v-if="showWelcomeBonusHeader" />

                    <layout-header-loyalty-program v-if="route.path === localePath('/loyalty-programm')" />
                    <layout-header
                        v-else-if="!isFrontPage"
                        :white-logo="isFrontPage"
                    />
                    <main class="flex grow">
                        <slot />
                    </main>

                    <slot name="footer" />
                </div>
            </div>

            <cookie-banner />
        </Body>
    </Html>
</template>

<script lang="ts" setup>
import type { KadeweUser } from "~/types";

const route = useRoute();
const { t } = useI18n();
const { $environment } = useNuxtApp();
const localePath = useLocalePath();
const user = useSanctumUser<KadeweUser>();
const head = useLocaleHead({
    dir: true,
    lang: true,
    seo: true,
});

const title = computed(() => t((route.meta.title ?? "layouts.title") as string));

const showWelcomeBonusHeader = false;

const isFrontPage = computed(() => route.path === localePath("/"));

const isStaging = computed(() => $environment() === "staging");
</script>
